// import * as React from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   Box,
//   Tooltip,
// } from "@mui/material";
// import {
//   ExpandLess,
//   ExpandMore,
//   HomeRounded as HomeRoundedIcon,
//   GroupAddRounded as GroupAddRoundedIcon,
//   AnalyticsRounded as AnalyticsRoundedIcon,
//   ApartmentRounded as ApartmentRoundedIcon,
//   DescriptionRounded as DescriptionRoundedIcon,
//   RequestQuoteRounded as RequestQuoteRoundedIcon,
//   InventoryRounded as InventoryRoundedIcon,
//   Build,
// } from "@mui/icons-material";

// // 🎨 React Icons
// import {
//   FaBoxOpen,
//   FaStore,
//   FaShoppingCart,
//   FaUser,
//   FaChartBar,
//   FaMoneyBillWave,
// } from "react-icons/fa";
// import { MdHome, MdSettings } from "react-icons/md";
// import { fetchPermission } from "../../Services/Services";
// import SettingsIcon from "@mui/icons-material/Settings";

// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import Diversity2Icon from "@mui/icons-material/Diversity2";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

// export default function MenuContent({ onItemClick }) {
//   const location = useLocation();
//   const [activeSection, setActiveSection] = React.useState(null);
//   const [activeSubSection, setActiveSubSection] = React.useState(null); // ✅ Nested ke liye
//   const [adminSubSection, setAdminSubSection] = React.useState(null);
//   const [purchaseEntrySection, setPurchaseEntrySection] = React.useState(null);
//    const [bomSection, setBomSection] = React.useState(false);
//   const [permissions, setPermissions] = React.useState([]);
//   const user_id = JSON.parse(localStorage.getItem("user_id")); // Still used for ID
//   const roleType = localStorage.getItem("role");

//   const [sidebarOpen, setSidebarOpen] = React.useState(
//     localStorage.getItem("sidebarOpen") !== "false",
//   );

//   React.useEffect(() => {
//     const handleToggle = () => {
//       setSidebarOpen(localStorage.getItem("sidebarOpen") !== "false");
//     };
//     window.addEventListener("sidebarToggle", handleToggle);
//     return () => window.removeEventListener("sidebarToggle", handleToggle);
//   }, []);

//   React.useEffect(() => {
//     const fetchPermissions = async () => {
//       try {
//         const response = await fetchPermission(user_id);
//         setPermissions(response || []);
//       } catch (error) {
//         console.error("Error fetching permissions:", error);
//       }
//     };

//     fetchPermissions();
//   }, [roleType, user_id]);

//   if (roleType !== "Admin" && permissions.length === 0) {
//     return <div>Loading menu...</div>;
//   }

//   const handleToggle = (section) => {
//     setActiveSection((prev) => (prev === section ? null : section));
//   };

//   const hasPermission = (group, label) => {
//     if (roleType === "Admin") return true;
//     return permissions.some((p) => p.group === group && p.label === label);
//   };

//   const isActive = (path) => location.pathname === path;

//   // 🔹 Updated styles – Blue theme
//   const getMainButtonStyle = (selected) => ({
//     backgroundColor: selected ? "#1976d2" : "transparent",
//     color: selected ? "#ffffff" : "#333333",
//     "&:hover": {
//       backgroundColor: selected ? "#1565c0" : "#e3f2fd",
//       color: selected ? "#ffffff" : "#1565c0",
//     },
//     borderRadius: "10px",
//     mb: 0.5,
//     mx: sidebarOpen ? 1 : 0.5,
//     minHeight: 44,
//     justifyContent: sidebarOpen ? "flex-start" : "center",
//     px: sidebarOpen ? 1.5 : 1,
//     transition: "all 0.2s ease",
//   });
//   const getSubItemStyle = (selected) => ({
//     pl: 4,
//     py: 0.25,
//     minHeight: 30,
//     backgroundColor: selected ? "#e3f2fd" : "transparent",
//     color: selected ? "#1565c0" : "#333333",
//     "&:hover": {
//       backgroundColor: "#bbdefb",
//       color: "#1565c0",
//     },
//     borderRadius: "8px",
//     mb: 0.25,
//     transition: "all 0.2s ease",
//   });

//   // 🔹 Icon colors – all blue shades
//   const iconColor = "#1976d2";
//   const iconColorSecondary = "#1565c0";

//   // 🔹 Helper function to conditionally set icon color based on active section
//   const getIconColor = (section) => {
//     return activeSection === section ? "#ffffff" : iconColor;
//   };

//   return (
//     <List dense>
//       {/* Home */}
//       {hasPermission("Dashboard", "Dashboard") && (
//         <Tooltip title={!sidebarOpen ? "Home" : ""} placement="right" arrow>
//           <ListItemButton
//             component={Link}
//             to="/dashboard/"
//             onClick={() => {
//               handleToggle("Home");
//               onItemClick?.();
//             }}
//             sx={getMainButtonStyle(isActive("/dashboard/"))}
//           >
//             <ListItemIcon
//               sx={{
//                 minWidth: sidebarOpen ? 40 : 0,
//                 mr: 0,
//                 justifyContent: "center",
//               }}
//             >
//               <MdHome
//                 style={{
//                   fontSize: "24px",
//                   color: isActive("/dashboard/") ? "#ffffff" : iconColor,
//                 }}
//               />
//             </ListItemIcon>
//             {sidebarOpen && <ListItemText primary="Home" />}
//           </ListItemButton>
//         </Tooltip>
//       )}

//       <Box sx={{ height: 5 }} />
//       {/* Setting */}
//       {(hasPermission("Settings", "Assign") ||
//         hasPermission("Settings", "Expense") ||
//         hasPermission("Settings", "Vendor") ||
//         hasPermission("Settings", "Profiles") ||
//         hasPermission("Settings", "Division") ||
//         hasPermission("Settings", "Imprest A/C") ||
//         hasPermission("Settings", "Adv worker") ||
//         hasPermission("Settings", "Transporters") ||
//         hasPermission("Settings", "Bank Accounts") ||
//         hasPermission("Settings", "Phase") ||
//         hasPermission("Settings", "BOM Creations") ||
//         hasPermission("Settings", "BOM Creations List") ||
//         hasPermission("Settings", "Voltage Ratio") ||
//         hasPermission("Settings", "Rating Specification") ||
//         hasPermission("Settings", "Winding Material")) && (
//         <>
//           <Tooltip>
//             <ListItemButton
//               onClick={() => handleToggle("Settings")}
//               sx={getMainButtonStyle(activeSection === "Settings")}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: sidebarOpen ? 40 : 0,
//                   mr: 0,
//                   justifyContent: "center",
//                 }}
//               >
//                 <MdSettings
//                   style={{ fontSize: "24px", color: getIconColor("Settings") }}
//                 />
//               </ListItemIcon>
//               {sidebarOpen && (
//                 <>
//                   <ListItemText primary="Settings" />
//                   {activeSection === "Settings" ? (
//                     <ExpandLess />
//                   ) : (
//                     <ExpandMore />
//                   )}
//                 </>
//               )}
//             </ListItemButton>
//           </Tooltip>

//           <Collapse
//             in={activeSection === "Settings" && sidebarOpen}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Settings", "Profiles") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/profiles"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/profiles"))}
//                 >
//                   <ListItemText primary="Profiles" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Settings", "Assign") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/role"
//                   sx={getSubItemStyle(isActive("/dashboard/role"))}
//                 >
//                   <ListItemText primary="Assign" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Settings", "Division") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/division"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/division"))}
//                 >
//                   <ListItemText primary="Division" />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Settings", "Creditor") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/vendor"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/vendor"))}
//                 >
//                   <ListItemText primary="Creditor" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Settings", "Debitor") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/Party"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/Party"))}
//                 >
//                   <ListItemText primary="Debtors" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Settings", "Expense") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/expense"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/expense"))}
//                 >
//                   <ListItemText primary="Expense" />
//                 </ListItemButton>
//               )} */}

//               {/* {hasPermission("Settings", "Imprest A/C") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/imprestmaster"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/imprestmaster"))}
//                 >
//                   <ListItemText primary="Imprest A/C" />
//                 </ListItemButton>
//               )} */}
//               {/*
//               {hasPermission("Settings", "Adv worker") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/advworker"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/advworker"))}
//                 >
//                   <ListItemText primary="Adv worker" />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Settings", "Bank Accounts") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/bank-accounts"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/bank-accounts"))}
//                 >
//                   <ListItemText primary="Bank Accounts" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Settings", "Phase") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/Phase"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/Phase"))}
//                 >
//                   <ListItemText primary="Phase" />
//                 </ListItemButton>
//               )}

//               {/* ─── BOM Nested Submenu ─── */}
//                {(hasPermission("Settings", "BOM Creation") ||
//                 hasPermission("Settings", "BOM Creation List")) && (
//                 <>
//                   <ListItemButton
//                     onClick={() => setBomSection((prev) => !prev)}
//                     sx={{
//                       ...getSubItemStyle(
//                         isActive("/dashboard/BOMCreation") ||
//                           isActive("/dashboard/BOMCreationList"),
//                       ),
//                       display: "flex",
//                       justifyContent: "space-between",
//                     }}
//                   >
//                     <ListItemText primary="BOM" />
//                     {bomSection ? (
//                       <ExpandLess sx={{ fontSize: "1.1rem", color: "#64748b" }} />
//                     ) : (
//                       <ExpandMore sx={{ fontSize: "1.1rem", color: "#64748b" }} />
//                     )}
//                   </ListItemButton>

//                   <Collapse in={bomSection} timeout="auto" unmountOnExit>
//                     <List component="div" disablePadding>
//                       {hasPermission("Settings", "BOM Creation") && (
//                         <ListItemButton
//                           component={Link}
//                           to="/dashboard/BOMCreation"
//                           onClick={onItemClick}
//                           sx={{
//                             ...getSubItemStyle(
//                               isActive("/dashboard/BOMCreation"),
//                             ),
//                             pl: 4,
//                           }}
//                         >
//                           <ListItemText
//                             primary="New BOM Formate"
//                             primaryTypographyProps={{ fontSize: "0.85rem" }}
//                           />
//                         </ListItemButton>
//                       )}

//                       {hasPermission("Settings", "BOM Creation List") && (
//                         <ListItemButton
//                           component={Link}
//                           to="/dashboard/BOMCreationList"
//                           onClick={onItemClick}
//                           sx={{
//                             ...getSubItemStyle(
//                               isActive("/dashboard/BOMCreationList"),
//                             ),
//                             pl: 4,
//                           }}
//                         >
//                           <ListItemText
//                             primary="BOM Formate"
//                             primaryTypographyProps={{ fontSize: "0.85rem" }}
//                           />
//                         </ListItemButton>
//                       )}
//                     </List>
//                   </Collapse>
//                 </>
//               )}

//               {hasPermission("Settings", "Voltage Ratio") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/VoltageRatio"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/VoltageRatio"))}
//                 >
//                   <ListItemText primary="Voltage Ratio" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Settings", "Rating Specification") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/RatingSpecification"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/RatingSpecification"),
//                   )}
//                 >
//                   <ListItemText primary="Rating Specification" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Settings", "Winding Material") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/WindingMaterial"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/WindingMaterial"))}
//                 >
//                   <ListItemText primary="Winding Material" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Settings", "Transporters") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/transporter"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/transporter"))}
//                 >
//                   <ListItemText primary="Transporters" />
//                 </ListItemButton>
//               )} */}
//             </List>
//           </Collapse>
//         </>
//       )}

//       <Box sx={{ height: 5 }} />

//       {/* Administrator */}
//       {/* {(hasPermission("Administrator", "Purchase Order") ||
//         hasPermission("Administrator", "Sale Order") ||
//         hasPermission("Administrator", "Indent list") ||
//         hasPermission("Administrator", "Performa Invoice") ||
//         hasPermission("Administrator", "Journal Voucher") ||
//         hasPermission("Administrator", "Purchase Voucher") ||
//         hasPermission("Administrator", "Payment Voucher") ||
//         hasPermission("Administrator", "Sales Voucher") ||
//         hasPermission("Administrator", "Receipt Voucher") ||
//         hasPermission("Administrator", "Contra Voucher")) && (
//         <>
//           <ListItemButton
//             onClick={() => handleToggle("Administrator")}
//             sx={getMainButtonStyle(activeSection === "Administrator")}
//           >
//             <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
//               <ManageAccountsIcon style={{ fontSize: "23px", color: "#000" }} />
//             </ListItemIcon>
//             <ListItemText primary="Administrator" />
//             {activeSection === "Administrator" ? (
//               <ExpandLess />
//             ) : (
//               <ExpandMore />
//             )}
//           </ListItemButton>

//           <Collapse
//             in={activeSection === "Administrator"}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Administrator", "Purchase Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-po-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/pending-po-list"))}
//                 >
//                   <ListItemText primary="Purchase Order" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Sale Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-so-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/pending-so-list"))}
//                 >
//                   <ListItemText primary="Sale Order" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Indent list") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-indent-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-indent-list"),
//                   )}
//                 >
//                   <ListItemText primary="Indent list" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Performa Invoice") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-pi-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/pending-pi-list"))}
//                 >
//                   <ListItemText primary="Proforma Invoice" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Journal Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-general-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-general-list"),
//                   )}
//                 >
//                   <ListItemText primary="Journal Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Purchase Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-purchase-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-purchase-list"),
//                   )}
//                 >
//                   <ListItemText primary="Purchase Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Payment Voucher") && (
//                 <>
//                   <ListItemButton
//                     onClick={() => {
//                       setAdminSubSection(
//                         adminSubSection === "PaymentList"
//                           ? null
//                           : "PaymentList",
//                       );
//                     }}
//                     sx={getSubItemStyle(adminSubSection === "PaymentList")}
//                   >
//                     <ListItemText
//                       primary="Payment Voucher"
//                       sx={{ minWidth: "110px !important", mr: 0 }}
//                     />
//                     {adminSubSection === "PaymentList" ? (
//                       <ExpandLess />
//                     ) : (
//                       <ExpandMore />
//                     )}
//                   </ListItemButton>

//                   <Collapse
//                     in={adminSubSection === "PaymentList"}
//                     timeout="auto"
//                     unmountOnExit
//                   >
//                     <List component="div" disablePadding>
//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/pending-payment-list-cash"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/pending-payment-list-cash"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Cash" />
//                       </ListItemButton>

//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/pending-payment-list-bank"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/pending-payment-list-bank"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Bank" />
//                       </ListItemButton>
//                     </List>
//                   </Collapse>
//                 </>
//               )}

//               {hasPermission("Administrator", "Sales Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-sales-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-sales-list"),
//                   )}
//                 >
//                   <ListItemText primary="Sales Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Receipt Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-receipt-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-receipt-list"),
//                   )}
//                 >
//                   <ListItemText primary="Receipt Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Administrator", "Contra Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/pending-contra-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/pending-contra-list"),
//                   )}
//                 >
//                   <ListItemText primary="Contra Voucher" />
//                 </ListItemButton>
//               )}
//             </List>
//           </Collapse>
//         </>
//       )} */}
//       <Box sx={{ height: 5 }} />

//       {(hasPermission("Store", "Issue Note") ||
//         hasPermission("Store", "Transfer") ||
//         hasPermission("Store", "MTC") ||
//         hasPermission("Store", "Stock Items") ||
//         hasPermission("Store", "Indent") ||
//         hasPermission("Store", "Sub Category") ||
//         hasPermission("Store", "Category") ||
//         hasPermission("Store", "Unit") ||
//         hasPermission("Store", "Size") ||
//         hasPermission("Store", "Stock Dashboard") ||
//         hasPermission("Store", "Purchase Voucher") ||
//         hasPermission("Store", "Purchase List") ||
//         hasPermission("Store", "PE WithIndent") ||
//         hasPermission("Store", "PE WithoutIndent") ||
//         hasPermission("Store", "Purchase Order")) && (
//         <>
//           <Tooltip
//             title={!sidebarOpen ? "Store & Procurement" : ""}
//             placement="right"
//             arrow
//           >
//             <ListItemButton
//               onClick={() => handleToggle("Store")}
//               sx={getMainButtonStyle(activeSection === "Store")}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: sidebarOpen ? 40 : 0,
//                   mr: 0,
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaBoxOpen
//                   style={{ fontSize: "23px", color: getIconColor("Store") }}
//                 />
//               </ListItemIcon>
//               {sidebarOpen && (
//                 <>
//                   <ListItemText
//                     primary={
//                       <>
//                         <span>Store & </span>
//                         <br />
//                         <span>Procurement</span>
//                       </>
//                     }
//                   />
//                   {activeSection === "Store" ? <ExpandLess /> : <ExpandMore />}
//                 </>
//               )}
//             </ListItemButton>
//           </Tooltip>

//           <Collapse
//             in={activeSection === "Store" && sidebarOpen}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {/* {hasPermission("Store", "Store Dashboard") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/innerdashboard"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/innerdashboard"))}
//                 >
//                   <ListItemText primary="Dashboard" />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Store", "Category") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/category-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/category-list"))}
//                 >
//                   <ListItemText primary="Category" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Store", "Sub Category") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/subcategory-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/subcategory-list"))}
//                 >
//                   <ListItemText primary="Sub Category" />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Store", "Unit") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/unit"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/unit"))}
//                 >
//                   <ListItemText primary="Unit" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Store", "Size") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/size"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/size"))}
//                 >
//                   <ListItemText primary="Product Type" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Store", "Stock Items") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/item-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/item-list"))}
//                 >
//                   <ListItemText primary="Items" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Store", "Indent") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/indent-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/indent-list"))}
//                 >
//                   <ListItemText primary="Indent" />
//                 </ListItemButton>
//               )} */}

//               {/* {hasPermission("Store", "Purchase Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/powithoutindent"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/powithoutindent"))}
//                 >
//                   <ListItemText primary="Purchase Order" />
//                 </ListItemButton>
//               )} */}

//               {/* ...................................................................... */}
//               {hasPermission("Store", "Purchase Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/po-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/po-list"))}
//                 >
//                   <ListItemText primary="Purchase Order" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Store", "Purchase Order") && (
//                 <>
//                   <ListItemButton
//                     onClick={() => {
//                       setActiveSubSection(
//                         activeSubSection === "PurchaseOrder"
//                           ? null
//                           : "PurchaseOrder",
//                       );
//                     }}
//                     sx={getSubItemStyle(activeSubSection === "PurchaseOrder")}
//                   >
//                     <ListItemText primary="Purchase Order" />
//                     {activeSubSection === "PurchaseOrder" ? (
//                       <ExpandLess />
//                     ) : (
//                       <ExpandMore />
//                     )}
//                   </ListItemButton>

//                   <Collapse
//                     in={activeSubSection === "PurchaseOrder"}
//                     timeout="auto"
//                     unmountOnExit
//                   >
//                     <List component="div" disablePadding>
//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/po-list"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(isActive("/dashboard/po-list")),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Purchase List" />
//                       </ListItemButton>

//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/po-form"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(isActive("/dashboard/po-form")),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Indent PO" />
//                       </ListItemButton>

//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/powithoutindent"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/powithoutindent"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Purchase Order" />
//                       </ListItemButton>
//                     </List>
//                   </Collapse>
//                 </>
//               )} */}

//               {(hasPermission("Store", "Purchase Voucher") ||
//                 hasPermission("Store", "Purchase List") ||
//                 hasPermission("Store", "PE WithIndent") ||
//                 hasPermission("Store", "PE WithoutIndent")) && (
//                 <>
//                   <ListItemButton
//                     onClick={() => {
//                       setPurchaseEntrySection(
//                         purchaseEntrySection === "PurchaseEntry"
//                           ? null
//                           : "PurchaseEntry",
//                       );
//                     }}
//                     sx={getSubItemStyle(
//                       purchaseEntrySection === "PurchaseEntry",
//                     )}
//                   >
//                     <ListItemText primary="Purchase Entry" />

//                     {purchaseEntrySection === "PurchaseEntry" ? (
//                       <ExpandLess />
//                     ) : (
//                       <ExpandMore />
//                     )}
//                   </ListItemButton>

//                   <Collapse
//                     in={purchaseEntrySection === "PurchaseEntry"}
//                     timeout="auto"
//                     unmountOnExit
//                   >
//                     <List component="div" disablePadding>
//                       {hasPermission("Store", "Purchase List") && (
//                         <ListItemButton
//                           component={Link}
//                           to="/dashboard/purchase-list"
//                           onClick={onItemClick}
//                           sx={{
//                             ...getSubItemStyle(
//                               isActive("/dashboard/purchase-list"),
//                             ),
//                             pl: 6,
//                           }}
//                         >
//                           <ListItemText primary="Purchase List" />
//                         </ListItemButton>
//                       )}

//                       {hasPermission("Store", "PE WithIndent") && (
//                         <ListItemButton
//                           component={Link}
//                           to="/dashboard/pe-with-po"
//                           onClick={onItemClick}
//                           sx={{
//                             ...getSubItemStyle(
//                               isActive("/dashboard/pe-with-po"),
//                             ),
//                             pl: 6,
//                           }}
//                         >
//                           <ListItemText
//                             primary={
//                               <>
//                                 Purchase Entry
//                                 <br />
//                                 Against PO
//                               </>
//                             }
//                           />
//                         </ListItemButton>
//                       )}

//                       {hasPermission("Store", "PE WithoutIndent") && (
//                         <ListItemButton
//                           component={Link}
//                           to="/dashboard/pe-without-po"
//                           onClick={onItemClick}
//                           sx={{
//                             ...getSubItemStyle(
//                               isActive("/dashboard/pe-without-po"),
//                             ),
//                             pl: 6,
//                           }}
//                         >
//                           <ListItemText
//                             primary={
//                               <>
//                                 Direct Purchase
//                                 <br />
//                                 Entry
//                               </>
//                             }
//                           />
//                         </ListItemButton>
//                       )}
//                     </List>
//                   </Collapse>
//                 </>
//               )}

//               {hasPermission("Store", "Issue Note") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/issue-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/issue-list"))}
//                 >
//                   <ListItemText primary="Issue Note" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Store", "Transfer") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/transferlist"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/transferlist"))}
//                 >
//                   <ListItemText primary="Transfer" />
//                 </ListItemButton>
//               )} */}
//               {/* {hasPermission("Store", "MTC") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/mtc-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/mtc-list"))}
//                 >
//                   <ListItemText primary="MTC" />
//                 </ListItemButton>
//               )} */}
//             </List>
//           </Collapse>
//         </>
//       )}

//       <Box sx={{ height: 5 }} />

//       {/* Accounts */}
//       {(hasPermission("Accounts", "Accounts Dashboard") ||
//         hasPermission("Accounts", "Journal Voucher") ||
//         hasPermission("Accounts", "Payments") ||
//         hasPermission("Accounts", "Sales Voucher") ||
//         hasPermission("Accounts", "Receipt") ||
//         hasPermission("Accounts", "Order Inward") ||
//         hasPermission("Accounts", "Sale Order") ||
//         hasPermission("Accounts", "Performa Invoice") ||
//         hasPermission("Accounts", "Contra Voucher")) && (
//         <>
//           <Tooltip
//             title={!sidebarOpen ? "Project" : ""}
//             placement="right"
//             arrow
//           >
//             <ListItemButton
//               onClick={() => handleToggle("Accounts")}
//               sx={getMainButtonStyle(activeSection === "Accounts")}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: sidebarOpen ? 40 : 0,
//                   mr: 0,
//                   justifyContent: "center",
//                 }}
//               >
//                 <AccountBalanceIcon
//                   style={{ fontSize: "23px", color: getIconColor("Accounts") }}
//                 />
//               </ListItemIcon>
//               {sidebarOpen && (
//                 <>
//                   <ListItemText primary="Project" />
//                   {activeSection === "Accounts" ? (
//                     <ExpandLess />
//                   ) : (
//                     <ExpandMore />
//                   )}
//                 </>
//               )}
//             </ListItemButton>
//           </Tooltip>

//           <Collapse
//             in={activeSection === "Accounts" && sidebarOpen}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("", "Account Dashboard") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/cards"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/cards"))}
//                 >
//                   <ListItemText primary="Dashboard" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Accounts", "Order Inward") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/saleorder"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/saleorder"))}
//                 >
//                   <ListItemText primary="MOS Form" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Accounts", "Sale Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/saleorderlist"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/saleorderlist"))}
//                 >
//                   <ListItemText primary="MOS List" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Accounts", "Proforma Invoice") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/performatable"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/"))}
//                 >
//                   <ListItemText primary="Proforma Invoice" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Accounts", "Journal Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/general-voucher"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/general-voucher"))}
//                 >
//                   <ListItemText primary="Journal Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Accounts", "Contra Voucher") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/contra-voucher"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/contra-voucher"))}
//                 >
//                   <ListItemText primary="Contra Voucher" />
//                 </ListItemButton>
//               )} */}

//               {/* {hasPermission("Accounts", "Payments") && (
//                 <>
//                   <ListItemButton
//                     onClick={() => {
//                       setActiveSubSection(
//                         activeSubSection === "Payments" ? null : "Payments",
//                       );
//                     }}
//                     sx={getSubItemStyle(activeSubSection === "Payments")}
//                   >
//                     <ListItemText primary="Payment" />
//                     {activeSubSection === "Payments" ? (
//                       <ExpandLess />
//                     ) : (
//                       <ExpandMore />
//                     )}
//                   </ListItemButton>

//                   <Collapse
//                     in={activeSubSection === "Payments"}
//                     timeout="auto"
//                     unmountOnExit
//                   >
//                     <List component="div" disablePadding>
//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/payment-cash"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/payment-cash"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Cash" />
//                       </ListItemButton>

//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/payment-bank"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/payment-bank"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="Bank" />
//                       </ListItemButton>

//                       <ListItemButton
//                         component={Link}
//                         to="/dashboard/payment-voucher-neft-rtgs"
//                         onClick={onItemClick}
//                         sx={{
//                           ...getSubItemStyle(
//                             isActive("/dashboard/payment-voucher-neft-rtgs"),
//                           ),
//                           pl: 6,
//                         }}
//                       >
//                         <ListItemText primary="NEFT/RTGS" />
//                       </ListItemButton>
//                     </List>
//                   </Collapse>
//                 </>
//               )} */}

//               {/* {hasPermission("Accounts", "Receipt") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/receiptvoucher"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/receiptvoucher"))}
//                 >
//                   <ListItemText primary="Receipt" />
//                 </ListItemButton>
//               )} */}
//             </List>
//           </Collapse>
//         </>
//       )}
//       <Box sx={{ height: 5 }} />

//       {/* Operational Department */}
//       {/* {(hasPermission("Operational Department", "Design & Drawing") ||
//         hasPermission("Operational Department", "IBR Formalities") ||
//       hasPermission("Operational Department","Issue MTC")) && (
//         <>
//           <ListItemButton
//             onClick={() => handleToggle("Operational Department")}
//             sx={getMainButtonStyle(activeSection === "Operational Department")}
//           >
//             <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
//               <Diversity2Icon style={{ fontSize: "23px", color: "#f44336" }} />
//             </ListItemIcon>
//             <ListItemText
//               primary={
//                 <>
//                   <span>Operational </span>
//                   <br />
//                   <span>Department</span>
//                 </>
//               }
//             />
//             {activeSection === "Operational Department" ? (
//               <ExpandLess />
//             ) : (
//               <ExpandMore />
//             )}
//           </ListItemButton>

//           <Collapse
//             in={activeSection === "Operational Department"}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Operational Department", "Design & Drawing") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/design-and-drawing"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/design-and-drawing"),
//                   )}
//                 >
//                   <ListItemText primary="Design & Drawing" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Operational Department", "IBR Formalities") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/ibr-formalities"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/ibr-formalities"))}
//                 >
//                   <ListItemText primary="IBR Formalities" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Operational Department", "Issue MTC") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/issue-mtc-list"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/issue-mtc-list"))}
//                 >
//                   <ListItemText primary="Issue MTC" />
//                 </ListItemButton>
//               )}
//             </List>
//           </Collapse>
//         </>
//       )}
//       <Box sx={{ height: 5 }} />*/}

//       {(hasPermission("Sales & Marketing", "Enquiry") ||
//         hasPermission("Sales & Marketing", "Quotation") ||
//         hasPermission("Sales & Marketing", "Feedback")) && (
//         <>
//           <Tooltip
//             title={!sidebarOpen ? "Sales & Marketing" : ""}
//             placement="right"
//             arrow
//           >
//             <ListItemButton
//               onClick={() => handleToggle("Sales & Marketing")}
//               sx={getMainButtonStyle(activeSection === "Sales & Marketing")}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: sidebarOpen ? 40 : 0,
//                   mr: 0,
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaUser
//                   style={{
//                     fontSize: "21px",
//                     color: getIconColor("Sales & Marketing"),
//                   }}
//                 />
//               </ListItemIcon>
//               {sidebarOpen && (
//                 <>
//                   <ListItemText
//                     primary={
//                       <>
//                         <span>Sales & </span>
//                         <br />
//                         <span>Marketing</span>
//                       </>
//                     }
//                   />
//                   {activeSection === "Sales & Marketing" ? (
//                     <ExpandLess />
//                   ) : (
//                     <ExpandMore />
//                   )}
//                 </>
//               )}
//             </ListItemButton>
//           </Tooltip>

//           <Collapse
//             in={activeSection === "Sales & Marketing" && sidebarOpen}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Sales & Marketing", "Enquiry") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/Enquiry"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/Enquiry"))}
//                 >
//                   <ListItemText primary="Enquiry" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Sales & Marketing", "Quotation") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/quotation"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/quotation"))}
//                 >
//                   <ListItemText primary="Quotation" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Sales & Marketing", "Feedback") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/client"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/client"))}
//                 >
//                   <ListItemText primary="Feedback" />
//                 </ListItemButton>
//               )}
//             </List>
//           </Collapse>
//         </>
//       )}

//       <Box sx={{ height: 5 }} />

//       {/* Reports */}
//       {/* {(hasPermission("Reports", " Accounts Summary") ||
//         hasPermission("Reports", "Sales List") ||
//         hasPermission("Reports", "Transfer History") ||
//         hasPermission("Reports", "Proforma Invoice") ||
//         hasPermission("Reports", "Journal Vch. Report") ||
//         hasPermission("Reports", "Purchase Voucher Rpt") ||
//         hasPermission("Reports", "Purchase Report") ||
//         hasPermission("Reports", "Indent Report") ||
//         hasPermission("Reports", "Cash Ledger") ||
//         hasPermission("Reports", "Bank Ledger") ||
//         hasPermission("Reports", "Ledger Book") ||
//         hasPermission("Reports", "Sale Order") ||
//         hasPermission("Reports", "Daily Payment")) && (
//         <>
//           <ListItemButton
//             onClick={() => handleToggle("Reports")}
//             sx={getMainButtonStyle(activeSection === "Reports")}
//           >
//             <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
//               <FaChartBar style={{ fontSize: "23px", color: "#ff9800" }} />
//             </ListItemIcon>
//             <ListItemText primary="Reports" />
//             {activeSection === "Reports" ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse
//             in={activeSection === "Reports"}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Reports", " Accounts Summary") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/projectsummary"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/projectsummary"))}
//                 >
//                   <ListItemText primary=" Accounts Summary" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Cash Ledger") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/cash-ledger"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/cash-ledger"))}
//                 >
//                   <ListItemText primary="Cash Ledger" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Bank Ledger") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/bank-ledger"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/bank-ledger"))}
//                 >
//                   <ListItemText primary="Bank Ledger" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Ledger Book") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/ledger-book"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/ledger-book"))}
//                 >
//                   <ListItemText primary="Ledger Book" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Journal Vch. Report") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/journal-voucher-by-division"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/journal-voucher-by-division"),
//                   )}
//                 >
//                   <ListItemText primary="Journal Voucher" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Sale Order") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/sale-order-by-date"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/sale-order-by-date"),
//                   )}
//                 >
//                   <ListItemText primary="Sale Order" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Daily Payment") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/daily-payment"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/daily-payment"))}
//                 >
//                   <ListItemText primary="Daily Payment" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Reports", "Proforma Invoice") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/performa-list-bydate"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/performa-list-bydate"),
//                   )}
//                 >
//                   <ListItemText primary="Proforma Invoice" />
//                 </ListItemButton>
//               )}
//             </List>
//           </Collapse>
//         </>
//       )} */}
//       <Box sx={{ height: 5 }} />

//       {/* Stock Report*/}

//       {(hasPermission("Stock Reports", "Stock Summary") ||
//         hasPermission("Stock Reports", " Accounts Summary") ||
//         hasPermission("Stock Reports", "Stock Summary") ||
//         hasPermission("Stock Reports", "Material Inward") ||
//         hasPermission("Stock Reports", "Stock Ladger") ||
//         hasPermission("Stock Reports", "Material Issue") ||
//         hasPermission("Stock Reports", "Division wise material Issue Note") ||
//         hasPermission("Stock Reports", "Value of Closing Stock") ||
//         hasPermission("Stock Reports", "Fast and slow moving items") ||
//         hasPermission("Stock Reports", "Pending GRN") ||
//         hasPermission("Stock Reports", "Item Wise Consumption") ||
//         hasPermission("Stock Reports", "Indent Report") ||
//         hasPermission("Stock Reports", "PO Report") ||
//         hasPermission("Stock Reports", "Purchase Voucher-PO")) && (
//         <>
//           <Tooltip
//             title={!sidebarOpen ? "Stock Reports" : ""}
//             placement="right"
//             arrow
//           >
//             <ListItemButton
//               onClick={() => handleToggle("Stock Reports")}
//               sx={getMainButtonStyle(activeSection === "Stock Reports")}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: sidebarOpen ? 40 : 0,
//                   mr: 0,
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaChartBar
//                   style={{
//                     fontSize: "23px",
//                     color:
//                       activeSection === "Stock Reports" ? "#ffffff" : "#1976d2",
//                   }}
//                 />
//               </ListItemIcon>
//               {sidebarOpen && (
//                 <>
//                   <ListItemText primary="Stock Reports" />
//                   {activeSection === "Stock Reports" ? (
//                     <ExpandLess />
//                   ) : (
//                     <ExpandMore />
//                   )}
//                 </>
//               )}
//             </ListItemButton>
//           </Tooltip>

//           <Collapse
//             in={activeSection === "Stock Reports" && sidebarOpen}
//             timeout="auto"
//             unmountOnExit
//           >
//             <List component="div" disablePadding>
//               {hasPermission("Stock Reports", " Accounts Summary") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/projectsummary"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/projectsummary"))}
//                 >
//                   <ListItemText primary=" Project Summary" />
//                 </ListItemButton>
//               )}
//               {hasPermission("Stock Reports", "Stock Summary") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/stock-summary"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/stock-summary"))}
//                 >
//                   <ListItemText primary="Stock Summary" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Stock Ladger") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/stock-ledger"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/stock-ledger"))}
//                 >
//                   <ListItemText primary="Stock Ladger" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Reserve Stock Ladger") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/reserve-stock-ledger"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/reserve-stock-ledger"))}
//                 >
//                   <ListItemText primary="Reserve Stock Ladger" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Material Inward") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/material-inward-register"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/material-inward-register"),
//                   )}
//                 >
//                   <ListItemText primary="Material Inward" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Material Issue") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/material-issue-register"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/material-issue-register"),
//                   )}
//                 >
//                   <ListItemText primary="Material Issue" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission(
//                 "Stock Reports",
//                 "Division wise material Issue Note",
//               ) && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/department-wise-material-usage"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/department-wise-material-usage"),
//                   )}
//                 >
//                   <ListItemText
//                     primary={
//                       <>
//                         <span>Division Wise Material</span>
//                         <br />
//                         <span>Issue Note</span>
//                       </>
//                     }
//                   />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Stock Reports", "Value of Closing Stock") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/value-of-closing-stock"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/value-of-closing-stock"),
//                   )}
//                 >
//                   <ListItemText primary="Value of Closing Stock" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Item Wise Consumption") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/item-wise-consumption-report"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/item-wise-consumption-report"),
//                   )}
//                 >
//                   <ListItemText primary="Item Wise Consumption" />
//                 </ListItemButton>
//               )}

//               {hasPermission("Stock Reports", "Pending GRN") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/grn-pending-for-approval"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/grn-pending-for-approval"),
//                   )}
//                 >
//                   <ListItemText primary="Pending GRN" />
//                 </ListItemButton>
//               )}

//               {/* {hasPermission("Stock Reports", "Fast and slow moving items") && (
//                   <ListItemButton
//                     component={Link}
//                     to="/dashboard/fast-slow-moving-items"
//                     onClick={onItemClick}
//                     sx={getSubItemStyle(
//                       isActive("/dashboard/fast-slow-moving-items"),
//                     )}
//                   >
//                     <ListItemText primary="Fast Slow Moving Items" />
//                   </ListItemButton>
//                 )} */}

//               {/* {hasPermission("Stock Reports", "Indent Status") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/indent-status"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/indent-status"))}
//                 >
//                   <ListItemText primary="Indent Status" />
//                 </ListItemButton>
//               )} */}

//               {hasPermission("Stock Reports", "PO Status") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/po-status"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/po-status"))}
//                 >
//                   <ListItemText primary="PO Status" />
//                 </ListItemButton>
//               )}
//               {/* {hasPermission("Stock Reports", "PO Indent") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/po-indent"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(isActive("/dashboard/po-indent"))}
//                 >
//                   <ListItemText primary="PO Indent" />
//                 </ListItemButton>
//               )} */}
//               {hasPermission("Stock Reports", "Purchase Voucher PO") && (
//                 <ListItemButton
//                   component={Link}
//                   to="/dashboard/purchase-voucher-po"
//                   onClick={onItemClick}
//                   sx={getSubItemStyle(
//                     isActive("/dashboard/purchase-voucher-po"),
//                   )}
//                 >
//                   <ListItemText primary="Purchase Voucher PO" />
//                 </ListItemButton>
//               )}
//             </List>
//           </Collapse>
//         </>
//       )}
//     </List>
//   );
// }

import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
  useTheme,
  alpha,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  HomeRounded as HomeRoundedIcon,
  GroupAddRounded as GroupAddRoundedIcon,
  AnalyticsRounded as AnalyticsRoundedIcon,
  ApartmentRounded as ApartmentRoundedIcon,
  DescriptionRounded as DescriptionRoundedIcon,
  RequestQuoteRounded as RequestQuoteRoundedIcon,
  InventoryRounded as InventoryRoundedIcon,
  Build,
} from "@mui/icons-material";

import {
  FaBoxOpen,
  FaStore,
  FaShoppingCart,
  FaUser,
  FaChartBar,
  FaMoneyBillWave,
} from "react-icons/fa";
import { MdHome, MdSettings } from "react-icons/md";
// import { fetchPermission } from "../../Services/Services";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

export default function MenuContent({ onItemClick }) {
  const location = useLocation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const [activeSection, setActiveSection] = React.useState(null);
  const [activeSubSection, setActiveSubSection] = React.useState(null);
  const [adminSubSection, setAdminSubSection] = React.useState(null);
  const [purchaseEntrySection, setPurchaseEntrySection] = React.useState(null);
  const [bomSection, setBomSection] = React.useState(false);
  const [permissions, setPermissions] = React.useState([]);
  const user_id = JSON.parse(localStorage.getItem("user_id"));
  const roleType = localStorage.getItem("role");

  const [sidebarOpen, setSidebarOpen] = React.useState(
    localStorage.getItem("sidebarOpen") !== "false",
  );

  React.useEffect(() => {
    const handleToggle = () => {
      setSidebarOpen(localStorage.getItem("sidebarOpen") !== "false");
    };
    window.addEventListener("sidebarToggle", handleToggle);
    return () => window.removeEventListener("sidebarToggle", handleToggle);
  }, []);

  React.useEffect(() => {
    if (roleType === "Admin") {
      setPermissions("all");
    } else {
      const permissionKey = `user_permissions_${user_id}`;
      const raw = localStorage.getItem(permissionKey);
      const stored = JSON.parse(raw || "[]");
      console.log("🔑 Permission Key:", permissionKey);
      console.log("📦 Raw from localStorage:", raw);
      console.log("✅ Parsed Permissions:", stored);
      console.log("👤 Role:", roleType, "| User ID:", user_id);
      setPermissions(stored);
    }
  }, [roleType, user_id]);

  if (!roleType) return <div>Loading menu...</div>;
  if (
    roleType !== "Admin" &&
    Array.isArray(permissions) &&
    permissions.length === 0
  ) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <ListItemText primary="No permissions. Contact admin." />
      </Box>
    );
  }

  const handleToggle = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  const hasPermission = (group, label) => {
    if (roleType === "Admin" || permissions === "all") return true;
    if (!Array.isArray(permissions)) return false;
    const result = permissions.some(
      (p) => p.group === group && p.label === label,
    );
    if (!result) {
      console.log(`🚫 DENIED: ${group} → ${label}`);
    }
    return result;
  };

  const isActive = (path) => location.pathname === path;

  // ── Theme-aware style helpers ──

  const getMainButtonStyle = (selected) => ({
    backgroundColor: selected ? "#1976d2" : "transparent",
    color: selected
      ? "#ffffff"
      : isDark
        ? theme.palette.text.primary
        : "#333333",
    "&:hover": {
      backgroundColor: selected
        ? "#1565c0"
        : isDark
          ? alpha(theme.palette.primary.main, 0.15)
          : "#e3f2fd",
      color: selected ? "#ffffff" : isDark ? "#90caf9" : "#1565c0",
    },
    borderRadius: "10px",
    mb: 0.5,
    mx: sidebarOpen ? 1 : 0.5,
    minHeight: 44,
    justifyContent: sidebarOpen ? "flex-start" : "center",
    px: sidebarOpen ? 1.5 : 1,
    transition: "all 0.2s ease",
  });

  const getSubItemStyle = (selected) => ({
    pl: 4,
    py: 0.25,
    minHeight: 30,
    backgroundColor: selected
      ? isDark
        ? alpha(theme.palette.primary.main, 0.22)
        : "#e3f2fd"
      : "transparent",
    color: selected
      ? isDark
        ? "#90caf9"
        : "#1565c0"
      : isDark
        ? theme.palette.text.secondary
        : "#333333",
    "&:hover": {
      backgroundColor: isDark
        ? alpha(theme.palette.primary.main, 0.12)
        : "#bbdefb",
      color: isDark ? "#90caf9" : "#1565c0",
    },
    borderRadius: "8px",
    mb: 0.25,
    transition: "all 0.2s ease",
  });

  // Icon colors
  const iconColor = "#1976d2";

  const getIconColor = (section) => {
    return activeSection === section ? "#ffffff" : iconColor;
  };

  return (
    <List dense>
      {/* ── HOME ── */}
      {hasPermission("Dashboard", "Dashboard") && (
        <Tooltip title={!sidebarOpen ? "Home" : ""} placement="right" arrow>
          <ListItemButton
            component={Link}
            to="/dashboard/"
            onClick={() => {
              handleToggle("Home");
              onItemClick?.();
            }}
            sx={getMainButtonStyle(isActive("/dashboard/"))}
          >
            <ListItemIcon
              sx={{
                minWidth: sidebarOpen ? 40 : 0,
                mr: 0,
                justifyContent: "center",
              }}
            >
              <MdHome
                style={{
                  fontSize: "24px",
                  color: isActive("/dashboard/") ? "#ffffff" : iconColor,
                }}
              />
            </ListItemIcon>
            {sidebarOpen && <ListItemText primary="Home" />}
          </ListItemButton>
        </Tooltip>
      )}

      <Box sx={{ height: 5 }} />

      {/* ── SETTINGS ── */}
      {(hasPermission("Settings", "Assign") ||
        hasPermission("Settings", "Expense") ||
        hasPermission("Settings", "Vendor") ||
        hasPermission("Settings", "Profiles") ||
        hasPermission("Settings", "Division") ||
        hasPermission("Settings", "Imprest A/C") ||
        hasPermission("Settings", "Adv worker") ||
        hasPermission("Settings", "Transporters") ||
        hasPermission("Settings", "Bank Accounts") ||
        hasPermission("Settings", "Phase") ||
        hasPermission("Settings", "Department") ||
        hasPermission("Settings", "BOM Creation") ||
        hasPermission("Settings", "BOM Creation List") ||
        hasPermission("Settings", "Voltage Ratio") ||
        hasPermission("Settings", "Rating Specification") ||
        hasPermission("Settings", "Winding Material")) && (
        <>
          <Tooltip>
            <ListItemButton
              onClick={() => handleToggle("Settings")}
              sx={getMainButtonStyle(activeSection === "Settings")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <MdSettings
                  style={{ fontSize: "24px", color: getIconColor("Settings") }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText primary="Settings" />
                  {activeSection === "Settings" ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Settings" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Settings", "Profiles") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/profiles"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/profiles"))}
                >
                  <ListItemText primary="Profiles" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Assign") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/role"
                  sx={getSubItemStyle(isActive("/dashboard/role"))}
                >
                  <ListItemText primary="Assign" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Creditor") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/vendor"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/vendor"))}
                >
                  <ListItemText primary="Creditor" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Debitor") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/Party"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/Party"))}
                >
                  <ListItemText primary="Debtors" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Bank Accounts") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/bank-accounts"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/bank-accounts"))}
                >
                  <ListItemText primary="Bank Accounts" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Phase") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/Phase"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/Phase"))}
                >
                  <ListItemText primary="Phase" />
                </ListItemButton>
              )}
              {hasPermission("Settings", "Department") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/department"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/department"))}
                >
                  <ListItemText primary="Department" />
                </ListItemButton>
              )}

              {/* ── BOM Nested ── */}
              {(hasPermission("Settings", "BOM Creation") ||
                hasPermission("Settings", "BOM Creation List")) && (
                <>
                  <ListItemButton
                    onClick={() => setBomSection((prev) => !prev)}
                    sx={{
                      ...getSubItemStyle(
                        isActive("/dashboard/BOMCreation") ||
                          isActive("/dashboard/BOMCreationList"),
                      ),
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <ListItemText primary="BOM" />
                    {bomSection ? (
                      <ExpandLess
                        sx={{
                          fontSize: "1.1rem",
                          color: isDark ? "#90caf9" : "#64748b",
                        }}
                      />
                    ) : (
                      <ExpandMore
                        sx={{
                          fontSize: "1.1rem",
                          color: isDark ? "#90caf9" : "#64748b",
                        }}
                      />
                    )}
                  </ListItemButton>

                  <Collapse in={bomSection} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {hasPermission("Settings", "BOM Creation") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/BOMCreation"
                          onClick={onItemClick}
                          sx={{
                            ...getSubItemStyle(
                              isActive("/dashboard/BOMCreation"),
                            ),
                            pl: 4,
                          }}
                        >
                          <ListItemText
                            primary="New BOM Formate"
                            primaryTypographyProps={{ fontSize: "0.85rem" }}
                          />
                        </ListItemButton>
                      )}

                      {hasPermission("Settings", "BOM Creation List") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/BOMCreationList"
                          onClick={onItemClick}
                          sx={{
                            ...getSubItemStyle(
                              isActive("/dashboard/BOMCreationList"),
                            ),
                            pl: 4,
                          }}
                        >
                          <ListItemText
                            primary="BOM Formate"
                            primaryTypographyProps={{ fontSize: "0.85rem" }}
                          />
                        </ListItemButton>
                      )}
                    </List>
                  </Collapse>
                </>
              )}

              {hasPermission("Settings", "Voltage Ratio") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/VoltageRatio"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/VoltageRatio"))}
                >
                  <ListItemText primary="Voltage Ratio" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Rating Specification") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/RatingSpecification"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/RatingSpecification"),
                  )}
                >
                  <ListItemText primary="Rating Specification" />
                </ListItemButton>
              )}

              {hasPermission("Settings", "Winding Material") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/WindingMaterial"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/WindingMaterial"))}
                >
                  <ListItemText primary="Winding Material" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      <Box sx={{ height: 5 }} />

      {/* ── ADMINISTRATOR (APPROVALS) - Commented out for now ── */}
      {/* {(hasPermission("Administrator", "Purchase Order") ||
        hasPermission("Administrator", "Sale Order") ||
        hasPermission("Administrator", "Indent list") ||
        hasPermission("Administrator", "Performa Invoice") ||
        hasPermission("Administrator", "Journal Voucher") ||
        hasPermission("Administrator", "Purchase Voucher") ||
        hasPermission("Administrator", "Payment Voucher") ||
        hasPermission("Administrator", "Sales Voucher") ||
        hasPermission("Administrator", "Receipt Voucher") ||
        hasPermission("Administrator", "Contra Voucher")) && (
        <>
          <Tooltip
            title={!sidebarOpen ? "Administrator" : ""}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => handleToggle("Administrator")}
              sx={getMainButtonStyle(activeSection === "Administrator")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <ManageAccountsIcon
                  style={{
                    fontSize: "23px",
                    color: getIconColor("Administrator"),
                  }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText primary="Administrator" />
                  {activeSection === "Administrator" ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Administrator" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Administrator", "Purchase Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-po-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-po-list"))}
                >
                  <ListItemText primary="Purchase Order" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Sale Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-so-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-so-list"))}
                >
                  <ListItemText primary="Sale Order" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Indent list") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-indent-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-indent-list")
                  )}
                >
                  <ListItemText primary="Indent list" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Performa Invoice") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-pi-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-pi-list"))}
                >
                  <ListItemText primary="Proforma Invoice" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Journal Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-general-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-general-list")
                  )}
                >
                  <ListItemText primary="Journal Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Purchase Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-purchase-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-purchase-list")
                  )}
                >
                  <ListItemText primary="Purchase Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Payment Voucher") && (
                <>
                  <ListItemButton
                    onClick={() => {
                      setAdminSubSection(
                        adminSubSection === "PaymentList"
                          ? null
                          : "PaymentList"
                      );
                    }}
                    sx={getSubItemStyle(adminSubSection === "PaymentList")}
                  >
                    <ListItemText
                      primary="Payment Voucher"
                      sx={{ minWidth: "110px !important", mr: 0 }}
                    />
                    {adminSubSection === "PaymentList" ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={adminSubSection === "PaymentList"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/dashboard/pending-payment-list-cash"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/pending-payment-list-cash")
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Cash" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/pending-payment-list-bank"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/pending-payment-list-bank")
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Bank" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}
            </List>
          </Collapse>
        </>
      )} */}

      <Box sx={{ height: 5 }} />

      {/* ── STORE & PROCUREMENT ── */}
      {(hasPermission("Store", "Issue Note") ||
        hasPermission("Store", "Transfer") ||
        hasPermission("Store", "MTC") ||
        hasPermission("Store", "Stock Items") ||
        hasPermission("Store", "Accessories") ||
        hasPermission("Store", "Indent") ||
        hasPermission("Store", "Sub Category") ||
        hasPermission("Store", "Category") ||
        hasPermission("Store", "Unit") ||
        hasPermission("Store", "Size") ||
        hasPermission("Store", "Stock Dashboard") ||
        hasPermission("Store", "Purchase Voucher") ||
        hasPermission("Store", "Purchase List") ||
        hasPermission("Store", "PE WithIndent") ||
        hasPermission("Store", "PE WithoutIndent") ||
        hasPermission("Store", "Purchase Order")) && (
        <>
          <Tooltip
            title={!sidebarOpen ? "Store & Procurement" : ""}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => handleToggle("Store")}
              sx={getMainButtonStyle(activeSection === "Store")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <FaBoxOpen
                  style={{ fontSize: "23px", color: getIconColor("Store") }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText
                    primary={
                      <>
                        <span>Store & </span>
                        <br />
                        <span>Procurement</span>
                      </>
                    }
                  />
                  {activeSection === "Store" ? <ExpandLess /> : <ExpandMore />}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Store" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Store", "Product Type") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/size"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/size"))}
                >
                  <ListItemText primary="Product Type" />
                </ListItemButton>
              )}
              {hasPermission("Store", "Category") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/category-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/category-list"))}
                >
                  <ListItemText primary="Category" />
                </ListItemButton>
              )}

              {hasPermission("Store", "Stock Items") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/item-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/item-list"))}
                >
                  <ListItemText primary="Items" />
                </ListItemButton>
              )}

              {hasPermission("Store", "Unit") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/unit"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/unit"))}
                >
                  <ListItemText primary="Unit" />
                </ListItemButton>
              )}

              {hasPermission("Store", "Purchase Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/po-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/po-list"))}
                >
                  <ListItemText primary="Purchase Order" />
                </ListItemButton>
              )}

              {hasPermission("Store", "Purchase Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/mos-procurement"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/mos-procurement"))}
                >
                  <ListItemText primary="MOS Procurement" />
                </ListItemButton>
              )}

              {/* Purchase Entry nested */}
              {(hasPermission("Store", "Purchase Voucher") ||
                hasPermission("Store", "Purchase List") ||
                hasPermission("Store", "PE WithIndent") ||
                hasPermission("Store", "PE WithoutIndent")) && (
                <>
                  <ListItemButton
                    onClick={() => {
                      setPurchaseEntrySection(
                        purchaseEntrySection === "PurchaseEntry"
                          ? null
                          : "PurchaseEntry",
                      );
                    }}
                    sx={getSubItemStyle(
                      purchaseEntrySection === "PurchaseEntry",
                    )}
                  >
                    <ListItemText primary="Purchase Entry" />
                    {purchaseEntrySection === "PurchaseEntry" ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={purchaseEntrySection === "PurchaseEntry"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {hasPermission("Store", "Purchase List") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/purchase-list"
                          onClick={onItemClick}
                          sx={{
                            ...getSubItemStyle(
                              isActive("/dashboard/purchase-list"),
                            ),
                            pl: 6,
                          }}
                        >
                          <ListItemText primary="Purchase List" />
                        </ListItemButton>
                      )}

                      {hasPermission("Store", "PE WithIndent") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/pe-with-po"
                          onClick={onItemClick}
                          sx={{
                            ...getSubItemStyle(
                              isActive("/dashboard/pe-with-po"),
                            ),
                            pl: 6,
                          }}
                        >
                          <ListItemText
                            primary={
                              <>
                                Purchase Entry
                                <br />
                                Against PO
                              </>
                            }
                          />
                        </ListItemButton>
                      )}

                      {hasPermission("Store", "PE WithoutIndent") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/pe-without-po"
                          onClick={onItemClick}
                          sx={{
                            ...getSubItemStyle(
                              isActive("/dashboard/pe-without-po"),
                            ),
                            pl: 6,
                          }}
                        >
                          <ListItemText
                            primary={
                              <>
                                Direct Purchase
                                <br />
                                Entry
                              </>
                            }
                          />
                        </ListItemButton>
                      )}
                    </List>
                  </Collapse>
                </>
              )}

              {hasPermission("Store", "Issue Note") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/issue-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/issue-list"))}
                >
                  <ListItemText primary="Issue Note" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      <Box sx={{ height: 5 }} />

      {/* ── PROJECT (Accounts) ── */}
      {(hasPermission("Accounts", "Accounts Dashboard") ||
        hasPermission("Accounts", "Journal Voucher") ||
        hasPermission("Accounts", "Payments") ||
        hasPermission("Accounts", "Sales Voucher") ||
        hasPermission("Accounts", "Receipt") ||
        hasPermission("Accounts", "Order Inward") ||
        hasPermission("Accounts", "Sale Order") ||
        hasPermission("Accounts", "Proforma Invoice") ||
        hasPermission("Accounts", "Contra Voucher")) && (
        <>
          <Tooltip
            title={!sidebarOpen ? "Project" : ""}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => handleToggle("Accounts")}
              sx={getMainButtonStyle(activeSection === "Accounts")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <AccountBalanceIcon
                  style={{
                    fontSize: "23px",
                    color: getIconColor("Accounts"),
                  }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText primary="Project" />
                  {activeSection === "Accounts" ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Accounts" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Accounts", "Accounts Dashboard") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/cards"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/cards"))}
                >
                  <ListItemText primary="Dashboard" />
                </ListItemButton>
              )}
              {hasPermission("Accounts", "Order Inward") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/saleorder"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/saleorder"))}
                >
                  <ListItemText primary="MOS Form" />
                </ListItemButton>
              )}

              {hasPermission("Accounts", "Sale Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/saleorderlist"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/saleorderlist"))}
                >
                  <ListItemText primary="MOS List" />
                </ListItemButton>
              )}

              {hasPermission("Accounts", "Proforma Invoice") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/performatable"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/"))}
                >
                  <ListItemText primary="Proforma Invoice" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      <Box sx={{ height: 5 }} />

      {/* ── SALES & MARKETING ── */}
      {(hasPermission("Sales & Marketing", "Enquiry") ||
        hasPermission("Sales & Marketing", "Quotation") ||
        hasPermission("Sales & Marketing", "Feedback")) && (
        <>
          <Tooltip
            title={!sidebarOpen ? "Sales & Marketing" : ""}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => handleToggle("Sales & Marketing")}
              sx={getMainButtonStyle(activeSection === "Sales & Marketing")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <FaUser
                  style={{
                    fontSize: "21px",
                    color: getIconColor("Sales & Marketing"),
                  }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText
                    primary={
                      <>
                        <span>Sales & </span>
                        <br />
                        <span>Marketing</span>
                      </>
                    }
                  />
                  {activeSection === "Sales & Marketing" ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Sales & Marketing" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Sales & Marketing", "Enquiry") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/Enquiry"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/Enquiry"))}
                >
                  <ListItemText primary="Enquiry" />
                </ListItemButton>
              )}

              {hasPermission("Sales & Marketing", "Quotation") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/quotation"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/quotation"))}
                >
                  <ListItemText primary="Quotation" />
                </ListItemButton>
              )}
              {hasPermission("Sales & Marketing", "Quotation") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/win-quotation"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/win-quotation"))}
                >
                  <ListItemText primary="Won Quotations" />
                </ListItemButton>
              )}

              {hasPermission("Sales & Marketing", "Quotation") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/lose-quotation"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/lose-quotation"))}
                >
                  <ListItemText primary="Lost Quotations" />
                </ListItemButton>
              )}

              {hasPermission("Sales & Marketing", "Feedback") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/client"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/client"))}
                >
                  <ListItemText primary="Feedback" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      <Box sx={{ height: 5 }} />

      {/* ── STOCK REPORTS ── */}
      {(hasPermission("Stock Reports", "Stock Summary") ||
        hasPermission("Stock Reports", "Project Summary") ||
        hasPermission("Stock Reports", "Material Inward") ||
        hasPermission("Stock Reports", "Stock Ladger") ||
        hasPermission("Stock Reports", "Material Issue") ||
        hasPermission("Stock Reports", "Division wise material Issue Note") ||
        hasPermission("Stock Reports", "Value of Closing Stock") ||
        hasPermission("Stock Reports", "Fast and slow moving items") ||
        hasPermission("Stock Reports", "Pending GRN") ||
        hasPermission("Stock Reports", "Item Wise Consumption") ||
        hasPermission("Stock Reports", "Indent Report") ||
        hasPermission("Stock Reports", "PO Report") ||
        hasPermission("Stock Reports", "Purchase Voucher PO")) && (
        <>
          <Tooltip
            title={!sidebarOpen ? "Stock Reports" : ""}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => handleToggle("Stock Reports")}
              sx={getMainButtonStyle(activeSection === "Stock Reports")}
            >
              <ListItemIcon
                sx={{
                  minWidth: sidebarOpen ? 40 : 0,
                  mr: 0,
                  justifyContent: "center",
                }}
              >
                <FaChartBar
                  style={{
                    fontSize: "23px",
                    color:
                      activeSection === "Stock Reports" ? "#ffffff" : iconColor,
                  }}
                />
              </ListItemIcon>
              {sidebarOpen && (
                <>
                  <ListItemText primary="Stock Reports" />
                  {activeSection === "Stock Reports" ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>

          <Collapse
            in={activeSection === "Stock Reports" && sidebarOpen}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Stock Reports", "Project Summary") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/projectsummary"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/projectsummary"))}
                >
                  <ListItemText primary="Project Summary" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Stock Summary") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/stock-summary"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/stock-summary"))}
                >
                  <ListItemText primary="Stock Summary" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Stock Ladger") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/stock-ledger"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/stock-ledger"))}
                >
                  <ListItemText primary="Stock Ladger" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Reserve Stock Ladger") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/reserve-stock-ledger"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/reserve-stock-ledger"),
                  )}
                >
                  <ListItemText primary="Reserve Stock Ladger" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Material Inward") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/material-inward-register"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/material-inward-register"),
                  )}
                >
                  <ListItemText primary="Material Inward" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Material Issue") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/material-issue-register"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/material-issue-register"),
                  )}
                >
                  <ListItemText primary="Material Issue" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Value of Closing Stock") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/value-of-closing-stock"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/value-of-closing-stock"),
                  )}
                >
                  <ListItemText primary="Value of Closing Stock" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Item Wise Consumption") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/item-wise-consumption-report"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/item-wise-consumption-report"),
                  )}
                >
                  <ListItemText primary="Item Wise Consumption" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Pending GRN") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/grn-pending-for-approval"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/grn-pending-for-approval"),
                  )}
                >
                  <ListItemText primary="Pending GRN" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "PO Status") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/po-status"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/po-status"))}
                >
                  <ListItemText primary="PO Status" />
                </ListItemButton>
              )}

              {hasPermission("Stock Reports", "Purchase Voucher PO") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/purchase-voucher-po"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/purchase-voucher-po"),
                  )}
                >
                  <ListItemText primary="Purchase Voucher PO" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}
    </List>
  );
}
